// document.addEventListener("click", function (e) {
//     const topicEl = e.target.closest(".topics-container .topic");
//     if (!topicEl) return; // Only run if a topic was clicked
//     e.preventDefault();

//     const topic = topicEl.querySelector("h2").textContent.trim();

//     // Remove 'selected' from all topics
//     document.querySelectorAll(".topics-container .topic").forEach(el => {
//         el.classList.remove("selected");
//     });
//     topicEl.classList.add("selected");

//     // Hide all FAQs
//     document.querySelectorAll(".faqs .faq").forEach(el => {
//         if (el.getAttribute("data-category") !== topic) {
//             el.style.transition = "opacity .5s"
//             el.style.opacity = "0";
//             setTimeout(() => el.style.display = "none", 500);
//         }
//     });

//     // Show only the matching FAQ
//     document.querySelectorAll(`.faqs .faq[data-category="${topic}"]`).forEach(el => {
//         el.style.opacity = "1";
//         el.style.transition = "opacity 0.5s";
//         setTimeout(() => el.style.display = "block", 500);
//     });
// });    

document.addEventListener("click", function (e) {
    const topicEl = e.target.closest(".topics-container .topic");
    if (!topicEl) return; // Only run if a topic was clicked
    e.preventDefault();

    const topic = topicEl.querySelector("h2").textContent.trim();
    
    selectTopic(topic);
});

// Function to select and display topic
function selectTopic(topic) {
    // Remove 'selected' from all topics
    document.querySelectorAll(".topics-container .topic").forEach(el => {
        el.classList.remove("selected");
    });
    
    // Add 'selected' to matching topic
    document.querySelectorAll(".topics-container .topic").forEach(el => {
        if (el.querySelector("h2").textContent.trim() === topic) {
            el.classList.add("selected");
        }
    });

    // Hide all FAQs
    document.querySelectorAll(".faqs .faq").forEach(el => {
        if (el.getAttribute("data-category") !== topic) {
            el.style.transition = "opacity .1s";
            el.style.opacity = "0";
            setTimeout(() => el.style.display = "none", 10);
        }
    });

    // Show only the matching FAQ
    document.querySelectorAll(`.faqs .faq[data-category="${topic}"]`).forEach(el => {
        el.style.display = "block";
        el.style.transition = "opacity 0.5s";
        setTimeout(() => el.style.opacity = "1", 10);
    });

    // Scroll to the .columns section
    const columnsSection = document.querySelector(".columns");
    if (columnsSection) {
        setTimeout(() => {
            const topOffset = columnsSection.getBoundingClientRect().top + window.scrollY - 70; // change -100 to adjust offset
            window.scrollTo({ top: topOffset, behavior: "smooth" });
        }, 100);
    }
}

// Handle URL hash on page load
function selectTopicFromURL() {
    const hash = window.location.hash;
    if (hash && hash.startsWith("#tab=")) {
        const urlParam = hash.replace("#tab=", "");
        
        // Find matching topic
        document.querySelectorAll(".topics-container .topic").forEach(topicEl => {
            const topicText = topicEl.querySelector("h2").textContent.trim();
            // Convert topic text to URL format: "Shipping & Tax" -> "shipping-tax"
            const topicSlug = topicText.toLowerCase().replace(/\s+&\s+/g, "-").replace(/\s+/g, "-");
            
            if (topicSlug === urlParam) {
                // Select the matching topic
                setTimeout(() => selectTopic(topicText), 100);
            }
        });
    }
}

// Run on page load
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', selectTopicFromURL);
} else {
    selectTopicFromURL();
}
// Also handle hash changes (back/forward navigation)
window.addEventListener('hashchange', selectTopicFromURL);
